import { ReactElement } from 'react'
import {
  FormControl as ChakraFormControl,
  FormControlProps,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from '@chakra-ui/react'

type Props = FormControlProps & {
  children: Element | ReactElement
  label?: string
  error?: string
  helperText?: string
}

export const FormControl = ({ children, label, error, helperText }: Props) => {
  return (
    <ChakraFormControl isInvalid={Boolean(error)}>
      <FormLabel>{label}</FormLabel>
      {children}
      {!error && helperText ? (
        <FormHelperText>{helperText}</FormHelperText>
      ) : error ? (
        <FormErrorMessage>{error}</FormErrorMessage>
      ) : null}
    </ChakraFormControl>
  )
}
